import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { WebConfigDash } from '../../../../shared/models/webConfigDash.model';
import { WebConfigDashService } from '../../../../shared/services/webConfigDash.service';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-insert.dialog',
  templateUrl: '../../dialogs/insert/insert.dialog.html',
  styleUrls: ['../../dialogs/insert/insert.dialog.scss']
})

export class InsertDialogComponent {
  constructor(public dialogRef: MatDialogRef<InsertDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: WebConfigDash,
              public webConfigDashService: WebConfigDashService) { }

  formControl = new FormControl('', [
    Validators.required
    // Validators.email,
  ]);

  getErrorMessage() {
    return this.formControl.hasError('required') ? 'Required field' :
      this.formControl.hasError('email') ? 'Not a valid email' :
        '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public confirmInsert(): void {
    this.webConfigDashService.listInsertData(this.data);
  }
}

